import { createMigration } from './utils';

const TEXT_ASSET_CLASS_TYPES = ['CanvasTextAsset', 'CanvasCaptionAsset', 'CanvasFancyCaptionAsset'];

export const migrationTo9_226 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('sceneGroups', []).forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations((map) => {
            const captionAsset = map.getIn(['captions', 'asset']) as any;
            if (!captionAsset) {
                return;
            }

            const classType = captionAsset.get('classType');

            // Remove dynamic styling properties from caption assets
            if (TEXT_ASSET_CLASS_TYPES.includes(classType)) {
                const basePath = ['captions', 'asset'];
                if (captionAsset.has('objectAnimation')) {
                    map.removeIn([...basePath, 'objectAnimation']);
                }
                if (captionAsset.has('colorGraphics')) {
                    map.removeIn([...basePath, 'colorGraphics']);
                }
                if (captionAsset.has('alphaGraphics')) {
                    map.removeIn([...basePath, 'alphaGraphics']);
                }
            }
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            map.get('children', []).forEach((child, cIndex) => {
                const path = ['children', cIndex];
                const asset = map.getIn(path) as any;
                if (!asset) {
                    return;
                }

                const classType = asset.get('classType');

                // Remove dynamic styling properties from TextAssets and ColorAssets
                if (TEXT_ASSET_CLASS_TYPES.includes(classType) || classType === 'ColorAsset') {
                    // Remove the properties if they exist directly on the asset
                    if (asset.has('objectAnimation')) {
                        map.removeIn([...path, 'objectAnimation']);
                    }
                    if (asset.has('colorGraphics')) {
                        map.removeIn([...path, 'colorGraphics']);
                    }
                    if (asset.has('alphaGraphics')) {
                        map.removeIn([...path, 'alphaGraphics']);
                    }
                }
            });
        });
    },
});
